import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import type { NodeKey } from "lexical";
import { $getNodeByKey, COMMAND_PRIORITY_LOW } from "lexical";
import type { FC } from "react";
import { useEffect } from "react";
import { $isDataTableNode } from "../nodes/data-table-node";
import { $isDesignHuddleNode } from "../nodes/design-huddle-node";
import { $isDynamicContentNode } from "../nodes/dynamic-content/dynamic-content-node";
import { $isImageNode } from "../nodes/image-node";
import { $isPollNode } from "../nodes/poll/helpers";
import { $isVideoNode } from "../nodes/video-node";
import { DELETE_NODE_COMMAND } from "../types/commands";

const useDeleteNodeCommands = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          DELETE_NODE_COMMAND,
          (key: NodeKey) => {
            const node = $getNodeByKey(key);
            if (
              $isImageNode(node) ||
              $isDesignHuddleNode(node) ||
              $isDynamicContentNode(node) ||
              $isPollNode(node) ||
              $isVideoNode(node) ||
              $isDataTableNode(node)
            ) {
              node.remove();
              return true;
            }

            return false;
          },
          COMMAND_PRIORITY_LOW,
        ),
      ),
    [editor],
  );

  return null;
};

export const DeleteNodePlugin: FC = () => {
  useDeleteNodeCommands();
  return null;
};
